module.exports = "body {\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./App/Components/change-password.component.css
// module id = 562
// module chunks = 1